import api from '@/shared/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import config from '@/config';
import handleHttpError from '@/shared/services/HandleHttpError';
import { SettingsQueryKey } from './queryKey';
export var useUpdateDocumentSettings = function () {
    var intl = useIntl();
    var queryClient = useQueryClient();
    var _a = useMutation(function (model) {
        return api.base
            .put("".concat(config.appUrls.documents, "/api/settings/"), model)
            .then(function (res) { return res.data; });
    }, {
        onSuccess: function (result) {
            queryClient.setQueryData([SettingsQueryKey.DocumentSettings], result);
        },
        onError: function (apiError) {
            handleHttpError(intl)(apiError);
        },
    }), mutateAsync = _a.mutateAsync, isLoading = _a.isLoading;
    return { updateDocumentSettings: mutateAsync, isLoading: isLoading };
};
